var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-wrapper d-flex align-end"},[_c('router-link',{staticClass:"nav-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/icons/logo.svg"),"alt":"logo"}})]),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }